// Slick JS
import 'slick-carousel/slick/slick.min';
  
  // CORPORATE SLIDER
  // $('#corporate-slider').slick({
  //   dots: true,
  //   slidesToScroll: 4,
  //   slidesToShow: 4,
  //   arrows: true,
  //   infinite: true,
  //   centerMode: true,
  //   responsive: [{
  
  //       breakpoint: 1199,
  //       settings: {
  //         arrows: true,
  //         slidesToShow: 3,
  //         slidesToScroll: 3,
  //       }
  //     },
  //     {
  
  //       breakpoint: 991,
  //       settings: {
  //         arrows: true,
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //       }
  //     },
  //     {
  
  //       breakpoint: 768,
  //       settings: {
  //         arrows: false,
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //       }
  //     },
  //     {
  
  //       breakpoint: 576,
  //       settings: {
  //         arrows: false,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       }
  //     },
  //   ]
  // });
  